// stores/colorStore.js
import { defineStore } from "pinia";

export const useColorStore = defineStore("colorStore", {
    state: () => ({
        favourites: [],
    }),
    actions: {
        add(color) {
            // console.log(color)
            if (!this.favourites.includes(color)) {
                this.favourites.push(color);
            }
        },
        remove(color) {
            this.favourites = this.favourites.filter((c) => c !== color);
        },
    },
    persist: true,
});
